//ナビゲーション、ハンバーガーメニュー
const _menuBtn = $('#js-hamburger')
const _header = $('#js-header')
const _navigation = $('#js-navigation')
const _anchorMenu = $('.js-anchor-link');

if (_menuBtn.length) {
	_menuBtn.on('click', function () {
		$('html').toggleClass('is-fixed')
		_menuBtn.toggleClass('is-show')
		_navigation.toggleClass('is-show')
		_header.toggleClass('is-show')
	})
}

// ページ内アンカーリンクをクリックしたらメニューを閉じる
_anchorMenu.on('click', function (e) {
	$('html').removeClass('is-fixed')
		_navigation.removeClass('is-show');
		_menuBtn.removeClass('is-show');
});

// TOPページのみヘッダーをスクロールで出現
document.addEventListener('DOMContentLoaded', function() {
  if (document.body.classList.contains('p-home')) {
    // ヘッダー途中から出現
    (function() {
      const header = document.querySelector('.l-header');
      window.addEventListener('scroll', () => {
        if (window.scrollY > 300) {
          header.classList.add('is-fixed');
        } else {
          header.classList.remove('is-fixed');
        }
      });
    }());
  }
});
